import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { ApprovalRules } from '../types';
import { ApprovalRulesRadioAnyHelpText } from './i18n/ApprovalRulesRadioI18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ApprovalRulesRadio = ({
  approvalType,
  onChangeApprovalRule
}) => {
  const onChange = evt => {
    onChangeApprovalRule(evt.target.value);
  };
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalRules.radioHeading"
    }),
    required: true,
    children: /*#__PURE__*/_jsxs(ToggleGroup, {
      name: "productApprovalsApprovalRules",
      children: [/*#__PURE__*/_jsx(RadioInput, {
        "data-test-id": "approval-rules-non-sequential",
        defaultChecked: true,
        value: ApprovalRules.NON_SEQUENTIAL,
        onChange: onChange,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRules.radioAll"
        })
      }), /*#__PURE__*/_jsxs(RadioInput, {
        "data-test-id": "approval-rules-any-can-approve",
        value: ApprovalRules.ANY_CAN_APPROVE,
        onChange: onChange,
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRules.radioAny.main"
        }), /*#__PURE__*/_jsx(Small, {
          use: "help",
          display: "block",
          children: /*#__PURE__*/_jsx(ApprovalRulesRadioAnyHelpText, {
            approvalType: approvalType
          })
        })]
      })]
    })
  });
};